const protocol = () => import('@/pages/content/protocol/index.vue');

export default [{
    path: '/content/protocol',
    component: protocol,
    meta: [{
        name: '内容管理'
    },
    {
        name: '协议管理',
        activeRoute: '/content/protocol'
    }]
}];